export const CARD_STYLES = [
  { id: 'plastic', label: 'Пластик' },
  { id: 'metallic', label: 'Металлик' },
  { id: 'matte', label: 'Матовый' },
  { id: 'glass', label: 'Стекло' },
];

export function getSurfaceOverlay(cardStyle) {
  switch (cardStyle) {
    case 'metallic':
      return 'linear-gradient(135deg, rgba(255,255,255,0.45) 0%, transparent 42%, rgba(0,0,0,0.22) 100%)';
    case 'matte':
      return 'linear-gradient(rgba(0,0,0,0.04), rgba(0,0,0,0.04))';
    case 'glass':
      return 'linear-gradient(to bottom, rgba(255,255,255,0.28), rgba(255,255,255,0.06))';
    case 'plastic':
    default:
      return 'linear-gradient(rgba(0,0,0,0.08), rgba(0,0,0,0.08))';
  }
}

export function buildCardBackground({ imageUrl, cardStyle }, withMedia) {
  const layers = [getSurfaceOverlay(cardStyle)];
  if (withMedia && imageUrl) {
    layers.push(`url(${imageUrl})`);
  }
  return layers.join(', ');
}

/** Полноэкранный фон открытой карты: картинка шаблона или только цвет + стиль */
export function buildDetailCardBackground(style) {
  if (!style.imageUrl) {
    return getSurfaceOverlay(style.cardStyle);
  }
  return [
    'linear-gradient(165deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%)',
    'radial-gradient(ellipse at 30% 20%, rgba(255,255,255,0.18) 0%, transparent 55%)',
    getSurfaceOverlay(style.cardStyle),
    `url(${style.imageUrl})`,
  ].join(', ');
}

export function getSurfaceClassName(cardStyle) {
  return `card-surface-${cardStyle || 'plastic'}`;
}
